'use strict';
import Common from '../../Utils/Common';

/**
 * @classname BtnFavorite
 * @classdesc お気に入りボタン
 */
export default class BtnFavorite {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--favorite
	 * @param {instance} controller - controller instance
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._itemId = itemId;
		this._logined = false;
		if($('.header').hasClass('header--logined')) this._logined = true;
		$e.on('click', () => this.onClick());
		this._controller.on('onFavoriteComplete', () => {
			if(this._itemId == this._controller._itemId) {
				this.favoriteComplete();
			}
		});
		this._controller.on('onError', () => {
			this._controller._itemId = null;
		});
	};


	/**
	 * clickイベントのコールバック
	 *
	 * @memberof BtnFavorite
	 * @return undefined
	 */
	onClick() {
		if($('body').hasClass('page-preview')) return;
		console.log(`${this.constructor.name}.onClick`);
		if(this._logined){
			if(this._$e.hasClass('on')){
				this._controller.favorite(this._itemId, false);
			}else{
				this._controller.favorite(this._itemId, true);
			}
		} else {
			let redirect = location.href;
			redirect = encodeURIComponent(redirect);
			const url = window.const.URL.LOGIN;
			console.log(url);
			location.href = `${url}?redirect_url=${redirect}`;
		}
	};


	/**
	 * お気に入り処理完了
	 *
	 * @memberof BtnFavorite
	 * @return undefined
	 */
	favoriteComplete() {
		console.log(`${this.constructor.name}.favoriteComplete`);
		if(this._$e.hasClass('on')){
			this._$e.removeClass('on');
			this._$e.html('<i class="icon icon--heart"></i>お気に入りに追加');
		}else{
			this._$e.addClass('on');
			this._$e.html('<i class="icon icon--heart-on"></i>お気に入りから削除');
		}
		this._controller._itemId = null;
	};
};
